import { selectAnatomy as n } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as r, defineStyle as s } from "@chakra-ui/react";
import { mergeWith as l } from "@chakra-ui/utils";
import e from "./input.mjs";
import { iconSizes as i } from "../../foundations/icons.mjs";
const { defineMultiStyleConfig: a } = r(n.keys), o = s({ paddingInlineEnd: "2rem" });
var t;
const g = a({
  baseStyle: {
    field: {
      ...((t = e.baseStyle) == null ? void 0 : t.field) || {},
      bg: "white",
      appearance: "none",
      "> option, > optgroup": {
        bg: "white"
      }
    },
    icon: {
      width: "1.5rem",
      height: "100%",
      insetEnd: "0.5rem",
      position: "relative",
      color: "teal.500",
      _disabled: {
        opacity: 0.5
      },
      _groupHover: {
        color: "teal.600"
      },
      _groupFocusWithin: {
        color: "teal.700"
      }
    }
  },
  sizes: l({}, e.sizes, {
    md: {
      field: o,
      icon: {
        fontSize: { base: i.sm, md: i.md }
      }
    },
    sm: {
      field: o,
      icon: {
        fontSize: { base: i.xs, md: i.sm }
      }
    }
  }),
  variants: e.variants,
  defaultProps: e.defaultProps
});
export {
  g as default
};
